// wizardDismissal — "jag stängde wizarden"-flagga per device. (#32)
//
// First-run-wizarden auto-öppnar på en ny device (tom localStorage).
// Innan denna flagga fanns naggade den vid VARJE besök tills user
// slutförde den med "Remember my choices" (vilket sparar en profil
// som suppressar auto-open). Nu räcker det att stänga den en gång.

export const WIZARD_DISMISSED_KEY = 'fw.wizardDismissed.v1';

export function isWizardDismissed(): boolean {
  try {
    return localStorage.getItem(WIZARD_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}
